import React from 'react';
import {Stack, Typography} from '@mui/material';
import apiService from '../../services/apiService';
import {ROLES} from '../../config/roles';
import Protected from '../Protected';
import EditableCard from '../EditableCard';
import MachineTechProfileForm from '../forms/MachineTechProfileForm';

/**
 * "Tech Profile" card on the machine detail page. View = labelled list of
 * every profile field. Edit = the 12-field numeric form, persisted via
 * PUT /api/machines/{id}/techProfile.
 *
 * Whole card is wrapped in {@code <Protected action="read">} — VIEWERS
 * don't see it at all. EditableCard handles the per-field edit gate via
 * the same component's {@code edit} ability.
 */
const MachineTechProfileCard = ({machine, onUpdated}) => (
    <Protected component={MachineTechProfileCard} action="read">
        <EditableCard
            title="Tech Profile"
            protectedBy={MachineTechProfileCard}
            protectAction="edit"
            value={machine.techProfile}
            save={(draft) => apiService.put(`/api/machines/${machine.id}/techProfile`, draft)}
            onSaved={onUpdated}
            successMessage="Tech profile saved"
            renderView={() => <TechProfileView techProfile={machine.techProfile}/>}
            renderForm={(draft, setDraft) => (
                <MachineTechProfileForm value={draft} onChange={setDraft}/>
            )}
        />
    </Protected>
);

const TechProfileView = ({techProfile}) => {
    if (!techProfile) return <Typography>—</Typography>;
    return (
        <Stack spacing={0.5}>
            {Object.entries(techProfile)
                .filter(([k]) => k !== 'id')
                .map(([k, v]) => (
                    <Typography key={k} variant="body2">
                        <strong>{humanize(k)}:</strong> {String(v)}
                    </Typography>
                ))}
        </Stack>
    );
};

const humanize = (camelCase) => camelCase.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase());

MachineTechProfileCard.abilities = {
    read: [ROLES.SUPPORT, ROLES.ADMINS],
    edit: [ROLES.ADMINS],
};

export default MachineTechProfileCard;
